module.exports = "/assets/data/3f2f0562e72cd24157babe37ac0ffb29-EC1V.data.json";